<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseComponent',
  inject: {
    loading: {
      default: false,
    },
  },
  inheritAttrs: false,
  props: {
    customClass: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'default',
    },
    variantProject: {
      type: String,
      default: 'default',
    },
    // eslint-disable-next-line vue/no-unused-properties
    classSkeleton: {
      type: String,
      default: '',
    },
    place: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/no-unused-properties
    skeleton: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /* eslint vue/no-unused-properties: off */
    adaptedAttrs() {
      return {
        ...this.$attrs,
        value: this.$attrs.value || this.$attrs.modelValue || this.$attrs['model-value'] || this.$attrs.value,
      };
    },
    isLoading(): boolean {
      // @ts-ignore
      return this.loading;
    },
    // eslint-disable-next-line vue/no-unused-properties
    classes() {
      const modifiers = [];
      if (this.disabled) {
        modifiers.push('m_disabled');
      }

      if (this.classSkeleton && this.isLoading) {
        this.classSkeleton.split(' ').filter(Boolean);
      }

      const variantProject = this.variantProject.split(',').filter(Boolean)
        .map(variantProject => {
          return variantProject.split(':');
        })
        .find(variant => variant[0] === this.$projectName)?.[1] ?? this.variant;

      const variant = this.place ? 'place' : variantProject;

      return {
        ['variant__' + variant]: variant,
        [modifiers.join(' ')]: modifiers.length,
        ['place__' + this.place]: this.place,
        [this.$attrs.class as string]: true,
        [this.$props.customClass]: true,
      };
    },
  },
});
</script>
